import axios from "axios";

import * as pdfjsLib from "pdfjs-dist/legacy/build/pdf";

// worker
pdfjsLib.GlobalWorkerOptions.workerSrc =
  "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.16.105/pdf.worker.min.js";

// =========================
// PDF URL
// =========================
const PDF_URL = "/pdf/quydinh.pdf";

// =========================
// MAP NAME PDF -> JSON
// =========================
const nameMap = {
  "VSound": "VSound",
  "SIM IoT": "SIM IoT",
  VPhone: "VPhone",
  VTablet: "VTablet",

  "iPhone 17e 256GB": "iPhone 17e",
  "iPhone Air 256GB": "iPhone 17 Air",
  "iPhone 17 256GB": "iPhone 17",

  "iPad Air 11 inch M4 128GB": "iPad Air M4",

  "MacBook NEO 8GB - 256GB": "MacBook NEO",

  "Galaxy A37 5G 8GB - 128GB": "Samsung Galaxy A37",
  "Galaxy A57 5G 8GB - 128GB": "Samsung Galaxy A57",
  "Galaxy S26 12GB - 512GB": "Samsung Galaxy S26",

  "Xiaomi Redmi 15C 8G - 256GB": "Xiaomi Redmi 15C",

  "POCO X8 Pro Max 12GB 256GB": "POCO X8 Pro Max",
};

// =========================
// PARSE MONEY
// =========================
function parseMoney(v) {
  if (!v) return 0;

  return parseInt(v.replace(/\./g, "").trim());
}

// =========================
// CLEAN TEXT
// =========================
function cleanText(str) {
  return str.replace(/\s+/g, " ").trim();
}

// =========================
// READ PDF TEXT
// =========================
async function extractPDFText(url) {
  const response = await axios.get(url, {
    responseType: "arraybuffer",
  });

  const loadingTask = pdfjsLib.getDocument({
    data: response.data,
  });

  const pdf = await loadingTask.promise;

  let fullText = "";

  for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
    const page = await pdf.getPage(pageNum);

    const textContent = await page.getTextContent();

    const pageText = textContent.items
      .map((item) => item.str)
      .join(" ");

    fullText += pageText + "\n";
  }

  return fullText;
}

// =========================
// MAIN
// =========================
export async function syncPriceFromPDF(products) {
  try {
    console.log("READ PDF...");

    const text = await extractPDFText(PDF_URL);

    console.log(text);

    // =========================
    // REGEX SCAN
    // =========================
    const productRegex =
      /(\d+)\s+([A-Za-z0-9\s.+-]+?)\s+(\d{1,3}(?:\.\d{3})+)\s+(\d{1,3}(?:\.\d{3})+)\s+(\d{1,3}(?:\.\d{3})+)\s+(\d{1,3}(?:\.\d{3})+)/g;

    let match;

    while ((match = productRegex.exec(text)) !== null) {
      let pdfName = cleanText(match[2]);

      const giaThueTD = parseMoney(match[3]);

      const giaThue = parseMoney(match[4]);

      const priceTD = parseMoney(match[5]);

      console.log({
        pdfName,
        giaThueTD,
        giaThue,
        priceTD,
      });

      // map tên
      let targetName = nameMap[pdfName] || pdfName;

      // tìm product
      const product = products.find((p) =>
        p.name.toLowerCase().includes(targetName.toLowerCase())
      );

      if (!product) {
        console.log("NOT FOUND:", pdfName);
        continue;
      }

      // update
      product.giaThueTD = giaThueTD;

      product.giaThue = giaThue;

      product.priceTD = priceTD;

      console.log("UPDATED:", product.name);
    }

    console.log("DONE");

    return products;
  } catch (err) {
    console.error(err);

    return products;
  }
}